import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"

import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
//import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

  import "flatpickr/dist/themes/material_blue.css";
  import Flatpickr from "react-flatpickr";



    const CallCenter = () => {

        toastr.options = TOAST_OPTIONS;
        const [modal_complaint, setmodal_complaint] = useState(false);
        const [isLoading, setIsLoading] = useState(false)


        
        const [trunks, setTrunks] = useState(['ANALOG_FWT_PORT_2', 'ANALOG_CAB_PORT_1'])
        const [depo, setDepo] = useState(['ANSWERED', 'NO ANSWER','BUSY','FAILED'])

        const [cdr, setCDR] = useState([])
        const [ext, setEXT] = useState([])

        const [sDate, setSDate]         = useState([new Date()])
        const [eDate, setEDate]         = useState([new Date()])
        const [sCaller, setSCaller]     = useState('')
        const [sCallee, setSCallee]     = useState('')
        const [sTrunk, setSTrunk]       = useState('')
        const [sDepo, setSDepo]         = useState('')
        
        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
 
        const tog_complaint = () => {
          fetchData()
          setmodal_complaint(!modal_complaint)
          removeBodyCss()
        }

        const fetchData = () => {
          const data = {
            caller    : sCaller,
            callee    : sCallee,
            trunk     : sTrunk,
            depo      : sDepo,
            startDate : formatDate(sDate),
            endDate   : formatDate(eDate),
          }
          setIsLoading(true)
          axios.post(url.CALLCENTERCDR, JSON.stringify(data), Config).then((r)=>{ 
            let cc = []
            if(r.data.cdr_root){
            
              r.data.cdr_root.map((d)=>{
                if(d.main_cdr){
                  if(d.sub_cdr_1){
                    cc.push(d.sub_cdr_1)
                  }
                  if(d.sub_cdr_2){
                    cc.push(d.sub_cdr_2)
                  }
                  if(d.sub_cdr_3){
                    cc.push(d.sub_cdr_3)
                  }
                  if(d.sub_cdr_4){
                    cc.push(d.sub_cdr_4)
                  }
                  if(d.sub_cdr_5){
                    cc.push(d.sub_cdr_5)
                  }
                  if(d.sub_cdr_6){
                    cc.push(d.sub_cdr_6)
                  }
                }else{
                   cc.push(d)
                }
              })
            }
            console.log(cc)
            setCDR(cc)
            setIsLoading(false)
          }).catch((e)=>{
            console.log(e);
            setIsLoading(false)
          })
          axios.get(url.CALLCENTEREXTS, Config).then((r)=>{ 
            if(r.data.response){
              setEXT(r.data.response.account)
            }else{
              toastr.warning("PBX busy, Try again later");
            }
          }).catch((e)=>{
            console.log(e);
          })
        }
        
        useEffect(() => {
          fetchData();
        },[]);

        const handleExport = () =>{
          const data = {
            caller    : sCaller,
            callee    : sCallee,
            trunk     : sTrunk,
            depo      : sDepo,
            startDate : formatDate(sDate),
            endDate   : formatDate(eDate),
          }
          setIsLoading(true)
          axios.post(`${url.COMPLAINTREPORT}`, JSON.stringify(data), Config).then((r)=>{ 
            setComplaints(r.data)
            const urlx = url.APACHE_URL + "attach/output.xlsx"
            axios({
              url: urlx,
              method: 'GET',
              responseType: 'blob',
            })
            .then((response) => {
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', `Complaints-Report.xlsx`);
               document.body.appendChild(link);
               link.click();
               document.body.removeChild(link);
               window.URL.revokeObjectURL(url);
             })
             .catch((error) => {
               console.error('Error downloading the file:', error);
             });
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
        }
        const handleFilterData = () =>{
          fetchData();
          /*const data = {
            caller    : sCaller,
            callee    : sCallee,
            trunk     : sTrunk,
            depo      : sDepo,
            startDate : formatDate(sDate),
            endDate   : formatDate(eDate),
          }
          setIsLoading(true)
          axios.post(`${url.CALLCENTERCDR}`, JSON.stringify(data), Config).then((r)=>{ 
            //setCDR(r.data.cdr_root)
            console.log(r)
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
          axios.get(url.CALLCENTEREXTS, Config).then((r)=>{ 
            setEXT(r.data.response.account)
          }).catch((e)=>{
            console.log(e);
          })
            */
        }
        const handleClearSearch = () =>{
          setSCaller('')
          setSTrunk('')
          setSDepo('')
          setSDate([new Date()])
          setEDate([new Date()])
          handleFilterData()
        }
    


              

        const columns1 = [

          {
            dataField: 'extension',
            text: 'EXT',
            sort: true,
            formatter: status1Formatter
          },
          {
            dataField: 'fullname',
            text: 'NAME',
            sort: true
          }
        ]
        
        const columns = [

        {
          dataField: 'start',
          text: 'START',
          sort: true
        },
        {
          dataField: 'action_owner',
          text: 'CALLER',
          sort: true
        }, 
        {
          dataField: 'action_type',
          text: 'DESTINATION',
          sort: true,
          formatter: destFormatter
        }, 
        {
          dataField: 'src_trunk_name',
          text: 'TRUNK',
          sort: true,
          formatter: trunkFormatter
        }, 
        
        {
          dataField: 'disposition',
          text: '',
          sort: true,
          formatter: statusFormatter
        }];

        const defaultSorted = [{
          dataField: 'start',
          order: 'desc'
        }];

        function destFormatter(cellContent, row){
          return (
            <div>{ row.action_type + ' '+ row.dst  }</div>
          )
        }
        function downFormatter(cellContent, row){
          if(row.recordfiles != ""){
            return (
              <div><Link to="#" onClick={()=>{
                    axios.post(url.CALLREC, JSON.stringify({'file':row.recordfiles}), Config).then((r)=>{ console.log(r) }).catch((e)=>{ console.log(e) })
              }}><i className="mdi mdi-cloud-download text-primary font-size-24 me-2"></i></Link></div>
            )
          }
        }
        function trunkFormatter(cellContent, row){
          return ( <div>{ row.src_trunk_name + ' '+ row.dst_trunk_name  }</div>)
        }
        function statusFormatter(cellContent, row) {
          if (row.disposition == "ANSWERED") {
            return (
              <div>
                  <Badge className="me-2 bg-success">{ cellContent }</Badge>
              </div>
            );
          }else if(row.disposition == "BUSY"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">{cellContent}</Badge>
              </div>
            );
          }else if(row.disposition == "NO ANSWER"){
            return (
              <div>
                  <Badge className="me-2 bg-secondary">{cellContent}</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">{ cellContent }</Badge>
              </div>
            );
          }
        }

        const defaultSorted1 = [{
          dataField: 'extension',
          order: 'asc'
        }];

        function status1Formatter(cellContent, row) {
          if (row.status == "Idle") {
            return (
              <div>
                  <Badge className={"font-size-12 badge-soft-success"} color='white'  pill>{cellContent}</Badge>
              </div>
            );
          }else if(row.status == "Unavailable"){
            return (
              <div>
                <Badge className={"font-size-12 badge-soft-danger"} color='white'  pill>{cellContent}</Badge>
              </div>
            );
          
          }else{
            return (
              <div>
                  <Badge className={"font-size-12 badge-soft-warning"} color='white'  pill>{cellContent}</Badge>
              </div>
            );
          }
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Call center report | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Row>
                            <Col lg="3">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">EXTENSIONS ({(ext || []).length})</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={12} sm={12}>
                                    <ToolkitProvider
                                      keyField="extension"
                                      data={ ext }
                                      columns={ columns1 }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                            
                                                <BootstrapTable 
                                                  keyField='extensions' 
                                                  data={ ext } 
                                                  columns={ columns1 } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted1 }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    </Col>

                                

                                    
                                    </Row>
                                </div>
                                
                  

                                </CardBody>
                                </Card>

                            </Col>
                                      
                            <Col lg="9">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">FILTER CALL RECORDS</h5>
                                <CardBody>
                                
                                

                                                
                                                <Row className="justify-content-center mb-2">
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>From</label>
                                                          <Flatpickr
                                                            className="form-control form-control-sm"
                                                            options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false
                                                            }}
                                                            value={sDate}
                                                            onChange={(dates)=>setSDate(dates)}
                                                            />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Till </label>
                                                          <Flatpickr
                                                              className="form-control form-control-sm"
                                                              options={{
                                                                  dateFormat: "Y-m-d",
                                                                  enableTime: false
                                                              }}
                                                              value={eDate}
                                                              onChange={(dates)=>setEDate(dates)}
                                                              />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Caller</label>
                                                          <input className="form-control form-control-sm" value={sCaller} onChange={(e)=>setSCaller(e.target.value)} />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Callee</label>
                                                          <input className="form-control form-control-sm" value={sCallee} onChange={(e)=>setSCallee(e.target.value)} />
                                                      </div>
                                                  </Col>
                            
                                                </Row>
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='danger'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Get Data
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  {/*<Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleExport()}}
                                                      >
                                                        <i className="mdi mdi-export me-1" />
                                                        Export to Excel
                                                      </Button>
                                                    </div>
                                                  </Col>*/}
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                                                <h5 className="card-header bg-transparent border-bottom text-uppercase">Data ({(cdr || []).length})</h5>
                                                  <CardBody>

                                    {(cdr || []).length > 0 && (
                                      <ToolkitProvider
                                      keyField="AcctId"
                                      data={ cdr }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  keyField='AcctId' 
                                                  data={ cdr } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    {((cdr || []).length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No data found</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default CallCenter;